import request from './AxiosRequest';

// infeed ad service

const browse = data =>
	request({
		url: `/Services/api/matangazo`,
		method: 'GET',
		data: data
	});

const Matangazo = {
	browse
};

export default Matangazo;